import * as yup from 'yup';
import { Language } from './slides/CustomSlide/LanguageSelector/hooks/useLanguageSelector';

export const validationSchema = yup.object().shape({
  backgroundColor: yup.string().required('Háttérszín megadása kötelező!'),
  textColor: yup.string().required('Szövegszín megadása kötelező!'),
  buttonColor: yup.string().required('Gomb színének megadása kötelező!'),
  buttonTextColor: yup.string().required('Gomb szövegének megadása kötelező!'),
  autoPlay: yup.boolean().required('Automatikus lejátszás megadása kötelező!'),
  // validáció a slideokra
  slides: yup
    .array()
    // legalább 1 slide szükséges, külöben error
    .min(1, 'Legalább 1 slide hozzáadása kötelező')
    .of(
      yup.object().shape({
        type: yup.string().required('Típus megadása kötelező!'),

        // event slide esetén egy event kiválasztása szükséges
        id: yup.number().when('type', {
          is: (slideType: string) => slideType === 'EVENT',
          then: (eventId) => eventId.required('Kérlek válassz a legördülő listából').min(1, 'Kérlek válassz a legördülő listából'),
        }),

        // product és package slide esetén egy id kiválasztása szükséges
        productVariantId: yup.number().when('type', {
          is: (slideType: string) => slideType === 'PACKAGE' || slideType === 'PRODUCT',
          then: (id) => id.required('Kérlek válassz a legördülő listából').min(1, 'Kérlek válassz a legördülő listából'),
        }),

        // custom slide esetén egy kép feltöltése szükséges
        image: yup.object().when('type', {
          is: (slideType: string) => slideType === 'CUSTOM',
          then: (image) =>
            image.shape({
              url: yup.string().required('Kép feltöltése kötelező').min(1, 'Kép megadása kötelező'),
            }),
        }),

        // custom slide esetén nyelvesített content ellenőrzése
        content: yup.object().when('type', {
          is: (slideType: string) => slideType === 'CUSTOM',
          then: () =>
            yup.lazy((content) => {
              // nyelvek listája
              const languages = Object.keys(content);

              // minden nyelvhez tartozó content validációja
              return yup.object().shape({
                ...languages.reduce((lang, value) => {
                  lang[value] = yup.object().shape({
                    title: yup.string().required(`${value.toUpperCase()} cím megadása kötelező`) as yup.StringSchema<string>,
                    description: yup.string().required(`${value.toUpperCase()} leírás megadása kötelező`) as yup.StringSchema<string>,
                    buttonText: yup.string().required(`${value.toUpperCase()} gomb szöveg megadása kötelező`) as yup.StringSchema<string>,
                    buttonLink: yup.string().required(`${value.toUpperCase()} gomb link megadása kötelező`) as yup.StringSchema<string>,
                  });

                  return lang;
                }, {} as Record<string, yup.ObjectSchema<Language>>),
              });
            }),
        }),
      }),
    ),
});
